import apiService from '../../sdk/apiService';

/**
 * Zmanim provider — delegates to existing apiService REST calls.
 * Keeps field names compatible with existing widgets.
 *
 * @param {{ lat: number, lng: number }} coordinates
 * @param {string} dateStr - ISO date string (YYYY-MM-DD)
 * @returns {Promise<object>} zmanim times as HH:MM strings
 */
export async function getZmanimData(coordinates, dateStr) {
  return apiService.fetchZmanimForDate(coordinates, dateStr);
}
